import type { IconDefinition } from '../index.tsx';

export const iconTag: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconTag',
  icon: [
    16,
    16,
    [],
    '',
    'M16 8L8 0H0V8L8 16L16 8ZM4.5 6C5.32843 6 6 5.32843 6 4.5C6 3.67157 5.32843 3 4.5 3C3.67157 3 3 3.67157 3 4.5C3 5.32843 3.67157 6 4.5 6Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
